import { StudyInfoDrawer } from '@/entities/study';
import { CustomTooltip } from '@/shared/ui/components';
import { zeroPad } from '@/shared/lib';
import _ from 'lodash';
import { t } from 'ttag';
import { useStudyList } from './useStudyList';
import type { StudyListProps } from './studyList.types';

/**
 * Lists the study IDs attached to a support request. Maps data to zero-padded friendlyId chips wrapped in a click-to-view tooltip calling toggleDisplayDrawer for the item, and mounts StudyInfoDrawer against the fetchStudyId and visibility held by useStudyList.
 *
 * @param props - Component props carrying the study list data.
 * @returns The study id list with its info drawer.
 */
const StudyList = (props: StudyListProps) => {
  const { data } = props;

  const { state, toggleDisplayDrawer } = useStudyList(props);

  return (
    <>
      <div className="study-list">
        {_.map(data, (item) => (
          <CustomTooltip placement="bottom" title={t`Click to view study info`}>
            <div
              key={item?.study?.id}
              className="study-item"
              onClick={() => {
                toggleDisplayDrawer(item);
              }}
              aria-hidden="true"
            >
              {zeroPad(item?.study?.friendlyId)}
            </div>
          </CustomTooltip>
        ))}
      </div>
      <StudyInfoDrawer
        visible={state.isVisibleStudyInfoDrawer}
        fetchStudyId={state.fetchStudyId}
        handleClickCloseButton={toggleDisplayDrawer}
      />
    </>
  );
};

export default StudyList;
